export default __webpack_public_path__ + "static/media/hht2_ep09_book_wp_01.efc732a0.jpg";